import { Component, OnInit } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AbstractSubscribeUnsubscribeDirective } from '@supoui/shared/components/abstract-subscribe-unsubscribe-directive';
import { AccountService } from '@supoui/core/auth/account.service';
import { VideoService } from '@supoui/help/services/video.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IVideo } from '@supoui/help/models/video';
import { ModalDialogConfiguration } from '@supoui/shared/model/modal/modal-dialog-configuration';
import { SERVER_API_URL } from '../../../app.constants';

@Component({
    selector: 'app-context-help-modal',
    templateUrl: './context-help-modal.component.html',
    styleUrls: ['./context-help-modal.component.scss'],
    standalone: false
})
export class ContextHelpModalComponent extends AbstractSubscribeUnsubscribeDirective implements OnInit {
  public readonly videoServerStreamUrl = `${SERVER_API_URL}services/supo-ui/video/stream/`;
  public readonly videoServerThumbnailUrl = `${SERVER_API_URL}services/supo-ui/video/thumbnail/`;

  modalDialogConfiguration: ModalDialogConfiguration;

  infotag: string;

  filteredVideos: IVideo[];
  videosError: any;
  videosLoading = true;

  private videos: IVideo[];

  private videoSubscription: Subscription;
  private languageChangedSubscription: Subscription;

  constructor(private accountService: AccountService, private videoService: VideoService, public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      headerText: 'Help'
    });

    this.accountService.getAuthenticationState().subscribe(account => {
      if (account) {
        this.loadVideos(account.langKey);
      }
    });

    this.languageChangedSubscription = this.accountService.languageChanged$
      .pipe(filter(languageKey => !!languageKey))
      .subscribe(languageKey => this.loadVideos(languageKey));
  }

  init(infotag: string): void {
    this.infotag = infotag;
    // this.filteredVideos = this.videos?.filter(video => video.infotags === infotag);
    // this.filteredVideos = this.videos?.filter(video => video.infotags.includes(infotag));
  }

  private loadVideos(langKey: string): void {
    this.videosLoading = true;
    this.videoSubscription = this.videoService
      .getVideos(langKey.toUpperCase())
      .pipe(
        switchMap(videos => {
          if (videos && videos.length) {
            return of(videos);
          } else {
            // Fallback to default language 'EN'
            return this.videoService.getVideos('EN');
          }
        })
      )
      .subscribe(
        videos => {
          this.videos = videos;
          this.filteredVideos = this.videos.filter(video => video.infotags.includes(this.infotag));
          this.videosLoading = false;
        },
        error => {
          this.videos = this.filteredVideos = [];
          this.videosError = error;
          this.videosLoading = false;
        }
      );
  }
}
